const hookFormError = {
  required: '必須項目です',
  maxLength20: '20文字以内で入力してください',
  maxLength100: '100文字以内で入力してください',
};

const success = {
  save: '保存しました',
  update: '更新しました',
  delete: '削除しました',
};

export const message = { hookFormError, success };
